import { z } from 'zod';
import { requiredText } from '@/shared/lib/validation';

/** Проверяет отчёт для завершения заказа */
export const completeOrderSchema = z.object({
    description: requiredText('Текст отчёта', 'Заполните поле «Текст отчёта»'),
    photos: z.array(z.instanceof(File)
        .refine((file) => file.type.startsWith('image/') && /\.(jpe?g|png|gif|bmp|webp)$/i.test(file.name),
            'Выберите изображение JPG, PNG, GIF, BMP или WebP')
        .refine((file) => file.size > 0, 'Фотография не должна быть пустой')
        .refine((file) => file.size <= 25_000_000, 'Размер фотографии не должен превышать 25 МБ')),
});

export type CompleteOrderFormValues = z.infer<typeof completeOrderSchema>;

export const COMPLETE_ORDER_DEFAULTS: CompleteOrderFormValues = {
    description: '',
    photos: [],
};
